// extracted by mini-css-extract-plugin
export var centerText = "_5v-8";
export var container = "_5v-0";
export var doughnutContainer = "_5v-7";
export var legend = "_5v-a";
export var legendItemColorDisplay = "_5v-b";
export var legendItemLabel = "_5v-d";
export var legendItemValue = "_5v-c";
export var lg = "_5v-5";
export var maxWidth = "_5v-9";
export var md = "_5v-4";
export var responsive = "_5v-6";
export var sm = "_5v-3";
export var xs = "_5v-2";
export var xxs = "_5v-1";